var map = {
	"./cameras.routes.js": 52536,
	"./devices.routes.js": 55485,
	"./grippers.routes.js": 39166,
	"./images.routes.js": 18012,
	"./products.routes.js": 32782,
	"./tasks.routes.js": 56870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54926;